import { render, staticRenderFns } from "./ChangePlataform.vue?vue&type=template&id=2b3522b0&"
import script from "./ChangePlataform.vue?vue&type=script&lang=js&"
export * from "./ChangePlataform.vue?vue&type=script&lang=js&"
import style0 from "./ChangePlataform.vue?vue&type=style&index=0&id=2b3522b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports